import React, { useState, useEffect } from 'react';
import Accordion from '../layout/accordion/Accordion';
import AccordionItem from '../layout/accordion/AccordionItem';
import CompanyList from './CompanyList';
import CompanySearch from './CompanySearch';
import CompanyCreationButton from './CompanyCreationButton';
import { fetchUserCompanies, fetchCompanies } from '../../utils/companies';
import { logger } from '../../utils/logger';
import styles from './Canvasses.module.css';

const CompanySelector = ({ onSelect, userCompanies }) => {
  const [publicCompanies, setPublicCompanies] = useState([]);
  const [selectedMyCompanyId, setSelectedMyCompanyId] = useState(null);
  const [selectedPublicCompanyId, setSelectedPublicCompanyId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    loadPublicCompanies();
  }, []);

  const loadPublicCompanies = async () => {
    try {
      setLoading(true);
      setError('');
      const result = await fetchCompanies({ isPublic: true, pageSize: 50 });
      setPublicCompanies(result.companies || []);
    } catch (err) {
      logger.error('Error loading public companies:', err);
      setError('Failed to load public companies');
    } finally {
      setLoading(false);
    }
  };

  const handleMyCompanySelect = (company) => {
    setSelectedMyCompanyId(company.id);
    setSelectedPublicCompanyId(null); // Clear public selection
    onSelect(company);
  };

  const handlePublicCompanySelect = (company) => {
    setSelectedPublicCompanyId(company.id);
    setSelectedMyCompanyId(null); // Clear my companies selection
    onSelect(company);
  };

  const handleCompanySelect = (company) => {
    // This is used for components that don't specify which section
    // Check if company is in userCompanies to determine the section
    const isMyCompany = userCompanies.some(c => c.id === company.id);
    if (isMyCompany) {
      handleMyCompanySelect(company);
    } else {
      handlePublicCompanySelect(company);
    }
  };

  return (
    <div className={styles.companySelector}>
      <h4>Select Organization:</h4>
      <p>Use an organization as context to inform the creation of a canvass.</p>
      
      <Accordion>
        <AccordionItem title="My Organizations">
          <CompanyList 
            companies={userCompanies}
            onSelect={handleMyCompanySelect}
            selectedCompanyId={selectedMyCompanyId}
          />
        </AccordionItem>
        
        <AccordionItem title="Public Organizations">
          <CompanySearch 
            companies={publicCompanies}
            onSelect={handlePublicCompanySelect}
            loading={loading}
            error={error}
            selectedCompanyId={selectedPublicCompanyId}
          />
        </AccordionItem>
        
        <AccordionItem title="Create New Organizations">
          <CompanyCreationButton onSuccess={handleCompanySelect} selectedCompanyId={selectedMyCompanyId} />
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default CompanySelector;
